import React, { useEffect, useState } from "react";
import { useActivityLog } from "./store";
import { Tab, Tabs } from "react-bootstrap";
import moment from "moment";
import ActivityData from "./ActivityData";
import NoOrderLogs from "assets/svgs/no_order_logs";
import EmptyEngagement from "assets/svgs/empty_engagement";
import EmptyAssignment from "assets/svgs/empty_assignment";
import EmptyMailbox from "assets/svgs/empty_mailbox";
import EmptyLog from "assets/svgs/empty_log";
import CardTabs from "modules/common/card-tabs/CardTabs";
import SoftBadge from "modules/common/SoftBadge";
import { filterAndSortLogsByKeyword, filterAndSortLogsByOther } from "modules/utilities/utility";

function ActivityLog({ customer, setMessageFloater }) {
  const {
    fetchActivityLogData,
    pageCount,
    clearActivityData,
    activityLogData,
  } = useActivityLog();
  const [allLogs, setAllLogs] = useState([]);
  const [orderLogs, setOrderLogs] = useState([]);
  const [assignmentLogs, setAssignmentLogs] = useState([]);
  const [slotsLogs, setSlotsLogs] = useState([]);
  const [messageLogs, setMessageLogs] = useState([]);
  const [otherLogs, setOtherLogs] = useState([]);
  const [page, setPage] = useState();

  const orderKeywords = [
    "BULK_ORDER",
    "ODA_WAREHOUSE_CREATED",
    "MEDICAL_REP_MARK_ORDER_SHIPPING",
    "ORDER_CAME_FOR_PROCESSING_AUTOMATICALLY",
    "ORDER_DELIVERED",
    "ORDER_DELIVERED_MANUAL",
    "ORDER_DIRECT_SHIPPING_PENDING",
    "ORDER_LINK_SENT",
    "ORDER_MARKED_AS_DELIVERED",
    "ORDER_MARKED_AS_RTO",
    "ORDER_SHIPPED",
    "ORDER_WAREHOUSE_CHANGED_VIA_AGENT",
    "ORDER_WAREHOUSE_CHANGED_VIA_SHOPIFY",
    "ORDER_WAREHOUSE_CREATED_VIA_AGENT",
    "This is ODA Order, Flag-duplicateCustomer",
    "This is ODA Order, Flag-nonServicable",
  ];

  const assignmentKeywords = [
    "ADMIN_LEAD_ASSIGNMENT",
    "ADMIN_ORDER_ASSIGNMENT",
    "MEDICAL_REP_ORDER_DOCTOR_ASSIGNMENT",
    "MEDICAL_REP_UNASSIGNED_DOCTOR",
    "TEMPORARY_ENGAGEMENT_ASSIGNMENT",
  ];

  const slotsAndEngagementKeywords = [
    "AUTO_SLOT_RESCHEDULED",
    "DOCTOR_APPT_SLOT_BOOKED",
    "SLOT_BOOKED",
    "SLOT_BOOKING_DISABLED",
    "CUSTOMER_ANSWERED_ENGAGEMENT_FEEDBACK",
    "ENGAGEMENT_UNANSWERED",
    "KNOWLARITY_CALL",
    "MEDICAL_REP_FINISHED_ENGAGEMENT",
    "TEMPORARY_ENGAGEMENT_ASSIGNMENT",
    "CONCERN_CALL_CREATED",
    "CONCERN_CALL_UPDATED_ATTEMPTS_1",
    "PRESCRIPTION_CALL_CREATED",
    "PRESCRIPTION_CALL_UPDATED_ATTEMPTS_1",
    "UNANSWERED_CONSULT_CALL",
  ];

  const messageKeywords = ["LIME_CHAT_MESSAGE_SENT"];

  useEffect(() => {
    clearActivityData();
    setPage(1);
  }, [customer.id]);

  useEffect(() => {
    setMessageFloater(true);
    page && fetchActivityLogData(customer.id, page);
  }, [customer]);

  useEffect(() => {
    page && fetchActivityLogData(customer.id, page);
  }, [page]);
  useEffect(() => {
    if (activityLogData) {
      setOrderLogs(filterAndSortLogsByKeyword(activityLogData, orderKeywords));
      setAssignmentLogs(
        filterAndSortLogsByKeyword(activityLogData, assignmentKeywords)
      );
      setSlotsLogs(
        filterAndSortLogsByKeyword(activityLogData, slotsAndEngagementKeywords)
      );
      setMessageLogs(
        filterAndSortLogsByKeyword(activityLogData, messageKeywords)
      );

      const excludeKeywords = [
        ...orderKeywords,
        ...assignmentKeywords,
        ...slotsAndEngagementKeywords,
        ...messageKeywords,
      ];
      setOtherLogs(filterAndSortLogsByOther(activityLogData, excludeKeywords));
      setAllLogs(activityLogData);
    }
  }, [activityLogData]);

  const loadMore =
    pageCount && page < pageCount ? (
      <div className="d-flex justify-content-center align-items-center p-2">
        <span
          onClick={() => {
            if (pageCount && page < pageCount) {
              setPage((prevPage) => prevPage + 1);
            }
          }}
        >
          <SoftBadge
            bg="success"
            className="text-shadow fs-1 m-2 cursor-pointer"
          >
            Load More...
          </SoftBadge>
        </span>
      </div>
    ) : (
      <></>
    );
  // const filterAndSortLogsByKeyword = (logs, keywords) => {
  //   const filteredLogs = logs.filter((log) => {
  //     if (log.event_id) {
  //       const logText = log.event_id;
  //       return keywords.some((keyword) => logText.includes(keyword));
  //     }
  //     return false;
  //   });

  //   const sortedLogs = filteredLogs.sort((alog, currentLog) => {
  //     return new Date(currentLog.updated_at) - new Date(alog.updated_at);
  //   });

  //   return sortedLogs;
  // };
  // const filterAndSortLogsByOther = (logs, excludeKeywords) => {
  //   const filteredLogs = logs.filter((log) => {
  //     if (log.event_id) {
  //       const logText = log.event_id.toLowerCase();
  //       return !excludeKeywords.some((keyword) =>
  //         logText.includes(keyword.toLowerCase())
  //       );
  //     }
  //     return false;
  //   });

  //   const sortedLogs = filteredLogs.sort((a, b) => {
  //     return new Date(b.updated_at) - new Date(a.updated_at);
  //   });

  //   return sortedLogs;
  // };

  const tabStyle = { height: "21.5rem", overflowY: "scroll" };

  const tabs = {
    "all logs": (
      <div style={tabStyle} className="scrollable-section">
        {allLogs.length ? (
          <div>
            {allLogs.map((log, index) => (
              <div
                key={index}
                className=" d-flex justify-content-between border rounded m-2 p-2"
              >
                <ActivityData activityLog={log} />
              </div>
            ))}
            {loadMore}
          </div>
        ) : (
          <div className=" d-flex gap-3 border rounded m-2 p-2">
            <NoOrderLogs />{" "}
            <span className="text-secondary fw-bold">No order logs</span>
          </div>
        )}
      </div>
    ),
    "order logs": (
      <div style={tabStyle} className="scrollable-section">
        {orderLogs.length ? (
          <div>
            {orderLogs.map((log, index) => (
              <div
                key={index}
                className=" d-flex justify-content-between border rounded m-2 p-2"
              >
                <ActivityData activityLog={log} />
              </div>
            ))}
            {loadMore}
          </div>
        ) : (
          <div className=" d-flex gap-3 border rounded m-2 p-2">
            <NoOrderLogs />{" "}
            <span className="text-secondary fw-bold">No order logs</span>
          </div>
        )}
      </div>
    ),
    "assignments logs": (
      <div style={tabStyle} className="scrollable-container">
        {assignmentKeywords.length && assignmentLogs[0] ? (
          <div>
            {assignmentLogs.map((log, index) => {
              return (
                <div
                  key={index}
                  className="d-flex justify-content-between border rounded m-2 p-2"
                >
                  <ActivityData activityLog={log} customer={customer} />
                </div>
              );
            })}
            {loadMore}
          </div>
        ) : (
          <div className=" d-flex gap-3 border rounded m-2 p-2">
            <EmptyEngagement />{" "}
            <span className="text-secondary fw-bold">No engagement logs</span>
          </div>
        )}
      </div>
    ),
    "slots & engagements logs": (
      <div style={tabStyle} className="scrollable-container">
        {slotsLogs.length ? (
          <div>
            {slotsLogs.map((log, index) => (
              <div
                key={index}
                className=" d-flex justify-content-between border rounded m-2 p-2"
              >
                <ActivityData activityLog={log} />
              </div>
            ))}
            {loadMore}
          </div>
        ) : (
          <div className=" d-flex gap-3 border rounded m-2 p-2">
            <EmptyAssignment />{" "}
            <span className="text-secondary fw-bold">No assignment logs</span>
          </div>
        )}
      </div>
    ),
    "message logs": (
      <div style={tabStyle} className="scrollable-container">
        {messageLogs.length ? (
          <div>
            {messageLogs.map((log, index) => (
              <div key={index} className="d-flex justify-content-end ">
                <div
                  className="w-50  border border-success rounded m-2 p-2"
                  style={{ background: "rgba(246, 255, 237, .4)" }}
                >
                  <div className="d-flex justify-content-between mb-3 align-items-start">
                    <p className="m-0 text-warning">{log.author_name}</p>
                    <small className="m-0 text-seondary ">
                      {moment(log.updated_at).format("MMM Do YYYY, h:mm a")}
                    </small>
                  </div>
                  <p className="m-0 w-100 text-break">
                    {log.meta.message.toString()}
                  </p>
                </div>
              </div>
            ))}
            {loadMore}
          </div>
        ) : (
          <div className=" d-flex gap-3 border rounded m-2 p-2">
            <EmptyMailbox />{" "}
            <span className="text-secondary fw-bold">No message logs</span>
          </div>
        )}
      </div>
    ),
    "other logs": (
      <div style={tabStyle} className="scrollable-container">
        {otherLogs.length ? (
          <div>
            {otherLogs.map((log, index) => (
              <div
                key={index}
                className="d-flex justify-content-between border rounded m-2 p-2"
              >
                <ActivityData activityLog={log} />
              </div>
            ))}
            {loadMore}
          </div>
        ) : (
          <div className=" d-flex gap-3 border rounded m-2 p-2">
            <EmptyLog />{" "}
            <span className="text-secondary fw-bold">No other logs</span>
          </div>
        )}
      </div>
    ),
  };
  return <CardTabs className="shadow-0" components={tabs} />;
}

export default ActivityLog;
